export default __webpack_public_path__ + "static/media/visa-maestro.8808745a.png";